import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark:
        {
          primary: '#009688',
          secondary: '#8bc34a',
          accent: '#ffc107',
          error: '#e91e63',
          warning: '#ff5722',
          info: '#03a9f4',
          success: '#4caf50',
          background: '#666666',
        },
      light:
        {
          primary: '#009688',
          secondary: '#8bc34a',
          accent: '#ffc107',
          error: '#e91e63',
          warning: '#ff5722',
          info: '#03a9f4',
          success: '#4caf50',
        },
    },
  },
})
